
import HeroSection from './components/HeroSection/HeroSection';

function Hw5Spotifycard() {
  return (
    <div>
      
      <HeroSection />
    </div>
  );
}

export default Hw5Spotifycard;